import type {
  EventArgs,
  EventFieldsSetByAPI,
  EventFieldsSetByEventsToolkit,
  EventNameType,
} from "@zapier/avro-events";
import { emit } from "@zapier/events-toolkit-browser";

export const EVENTS_SYSTEM_NAME = "support";

type RemoveAutoPopulatedEventFields<Type> = {
  [
    Property in keyof Type as Exclude<
      Property,
      EventFieldsSetByAPI | EventFieldsSetByEventsToolkit
    >
  ]: Type[Property];
};

const emitEvent = <T extends EventNameType>(
  eventName: T,
  customEventData?: RemoveAutoPopulatedEventFields<EventArgs<T>>,
  systemName?: string,
) => {
  // Don't emit events in development
  if (process.env.VERCEL_ENV === "development") {
    console.log(
      `⏰ Events-toolkit-browser: would have emitted "${eventName}" event.`,
      {
        ...customEventData,
        system_name: systemName || EVENTS_SYSTEM_NAME,
      },
    );
    return Promise.resolve() as Promise<any>;
  }

  return emit(
    {
      ...(customEventData || {}),
      system_name: systemName || EVENTS_SYSTEM_NAME,
    },
    eventName,
  );
};

export default emitEvent;
